import api from '@/api';
import { MembershipRole } from '@/types/api/membership';
import { useQuery } from '@tanstack/react-query';

export function useLinkInvitationQuery(role: MembershipRole) {
  return useQuery({
    queryKey: ['invitations', 'link', role],
    queryFn: () => api.membership.invitation.createLink({ role }),
    enabled: Boolean(role),
  });
}
